/**
 * Constant values for event categories, providing text description and image path
 */
export const eventCategories = {
  'CEL' : {
    text: 'Celebration',
    image: 'present.svg',
  },
  'CLU' : {
    text: 'Club',
    image: 'club.svg',
  },
  'EDU' : {
    text: 'Education',
    image: 'education.svg',
  },
  'MED' : {
    text: 'Medical',
    image: 'medical.svg',
  },
  'MUS' : {
    text: 'Music',
    image: 'music.svg',
  },
  'OUT' : {
    text: 'Outing',
    image: 'car.svg',
  },
  'OTH': {
    text: 'Other',
    image: 'other.svg',
  },
  'PET': {
    text: 'Pets',
    image: 'pets.svg',
  },
  'SHO': {
    text: 'Shopping',
    image: 'shopping.svg',
  },
  'SPO': {
    text: 'Sport',
    image: 'sport.svg',
  },
  'VAC': {
    text: 'Vacation',
    image: 'vacation.svg',
  },
  'WOR': {
    text: 'Work',
    image: 'work.svg',
  },
  'NON': {
    text: 'None',
    image: 'none.svg',
  }
}